import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity, mapToFormData } from './mapper';
import { PropertyType } from '../../../common';

export const createTemplate = (data: PropertyType): Promise<PropertyType> =>
	api.post('/user/create-report-filter-template', mapToFormData(mapEntityToApi(data)), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data.data);
	});
